import React from "react"

import { Link } from "react-router-dom"

import { faChevronLeft } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

class ManageHeader extends React.Component{
    render(){
        const { userId, gameName } = this.props
        return(
            <div id="detailHeader" role="navigation" style={{width: "100%"}}>
                <Link to={{pathname: `/console/user/${userId}`}}>
                    <FontAwesomeIcon icon={faChevronLeft} />&nbsp; Back to I have made
                </Link>
                <a href="/#">
                    <span style={{fontWeight: 700}}>&nbsp;&nbsp;|&nbsp;&nbsp;{gameName}</span>
                </a>
            </div>
        )
    }
}

export default ManageHeader